import _ from 'lodash'
import store from '../store'

const createQuery = (filters) => {
  if (!filters) return {}

  // For filter types that have an associated logical operator (AND, OR, EXCLUDE), they have a 
  // directive prepended to the object key. These need to be processed accordingly.

  const filterCategories = store.getters['SearchModule/getFilterCategories']
  let processedQuery = {}

  const { componentFilters, ...basicFilters } = _.cloneDeep(filters)
  delete basicFilters.appliedPreset // Do not submit preset information which is used for the frontend only

  // Process component filters
  for (const key in componentFilters) {
    const category = filterCategories.find(category => category.id === key)
    const value = componentFilters[key]
    processedQuery = {
      ...processedQuery,
      ...category.getServerKeys(value) // Use the server transform function from the category definition
    }
  }
  
  // Process basic filters
  for (const key in basicFilters) {
    const [logicalOperator, categoryId] = key.split('.')
    if (logicalOperator && categoryId) {
      // A conditional filter operation
      const category = filterCategories.find(category => category.id === categoryId)
      const serverKey = category.serverKey[logicalOperator]
      if (basicFilters[key]?.length) {
        // Map the transformed values to the server key
        processedQuery[serverKey] = basicFilters[key].map(value => {
          return category.valueTransform(value)
        })
      }
    } else {
      // A standard object field we don't need to process
      const value = basicFilters[key]
      if (value && (!Array.isArray(value) || value?.length)) {
        processedQuery[key] = basicFilters[key]
      }
    }
  }

  return processedQuery
}

// Takes a value array and a category (from filterOptions.js) and returns a formatted string of the values
const getValuesText = (valueArray, category) => {
  return valueArray.reduce((text, value, index) => {
    const optionName = category.options.find(option => category.valueTransform(option[category.optionValueKey]) === value)?.name ?? value
    const formattedName = optionName.replace(/ /g, '\u00A0') // Replace spaces with non-breaking spaces
    text += `${formattedName}${index < valueArray.length - 1 ? ', ' : ''}`
    return text
  }, '').trim()
}

// True when `filters` or `dateRange` would send at least one filter to the
// server. Mirrors createQuery: `appliedPreset` is frontend-only, empty arrays
// don't count, and an emptied componentFilters container doesn't count either.
// Optional `{ start, end }` date range counts as a filter too.
const hasAppliedFilters = (filters, dateRange) => {
  if (dateRange?.start || dateRange?.end) return true
  if (!filters) return false
  const basicFilters = _.cloneDeep(filters)
  const componentFilters = basicFilters.componentFilters
  delete basicFilters.appliedPreset
  delete basicFilters.componentFilters
  const isSet = value => Array.isArray(value) ? value.length > 0 : Boolean(value)
  return Object.values(componentFilters || {}).some(isSet) ||
    Object.values(basicFilters).some(isSet)
}

export {
  createQuery,
  getValuesText,
  hasAppliedFilters
}

// const conditionalFilterMaps = {
//   and: {
//     tags: {
//       name: 'andTag',
//       value: 'id',
//       transform: (value) => value
//     },
//     formats: {
//       name: 'andFormat',
//       value: 'name',
//       transform: (value) => value.toLowerCase()
//     },
//     niches: {
//       name: 'andNiche',
//       value: 'name',
//       transform: (value) => value
//     },
//     publisher_platform: {
//       name: 'andPublisherPlatform',
//       value: 'name',
//       transform: (value) => value.toLowerCase()
//     },
//     board_ids: {
//       name: 'andBoardId',
//       value: 'id',
//       transform: (value) => value
//     },
//     languages: {
//       name: 'andLanguages',
//       value: 'name',
//       transform: (value) => value
//     },
//     brands: {
//       name: 'andBrands',
//       value: 'brandId',
//       transform: (value) => value
//     }
//   },
//   or: {
//     tags: {
//       name: 'orTag',
//       value: 'id',
//       transform: (value) => value
//     },
//     formats: {
//       name: 'orFormat',
//       value: 'name',
//       transform: (value) => value.toLowerCase()
//     },
//     types: {
//       name: 'orFormat',
//       value: 'name',
//       transform: (value) => value
//     },
//     niches: {
//       name: 'orNiche',
//       value: 'name',
//       transform: (value) => value
//     },
//     contentFilters: {
//       name: 'orContentFilter',
//       value: 'name',
//       transform: (value) => value
//     },
//     publisher_platform: {
//       name: 'orPublisherPlatform',
//       value: 'name',
//       transform: (value) => value.toLowerCase()
//     },
//     board_ids: {
//       name: 'orBoardId',
//       value: 'id',
//       transform: (value) => value
//     },
//     liveStatus: {
//       name: 'orLiveStatus',
//       value: 'value',
//       transform: (value) => value
//     },
//     languages: {
//       name: 'orLanguages',
//       value: 'name',
//       transform: (value) => value
//     },
//     brands: {
//       name: 'orBrands',
//       value: 'brandId',
//       transform: (value) => value
//     },
//     marketTarget: {
//       name: 'orTargetMarket',
//       value: 'value',
//       transform: (value) => value
//     }
//   }
// }

// export function createQuery (filters) {
//   if (!filters) return {}

//   const { andFilters, orFilters, sort, favorites } = filters

//   let mappedAndFilters = {}
//   let mappedOrFilters = {}

//   if (andFilters) {
//     mappedAndFilters = Object.keys(andFilters).reduce((formattedAndFilters, filterKey) => {
//       const { name, value, transform } = conditionalFilterMaps.and[filterKey]

//       andFilters[filterKey].forEach(filter => {
//         if (formattedAndFilters[name]) {
//           formattedAndFilters[name].push(transform(filter[value]))
//         } else {
//           formattedAndFilters[name] = [transform(filter[value])]
//         }
//       })

//       return formattedAndFilters
//     }, {})
//   }

//   if (orFilters) {
//     mappedOrFilters = Object.keys(orFilters).reduce((formattedOrFilters, filterKey) => {
//       const { name, value, transform } = conditionalFilterMaps.or[filterKey]

//       orFilters[filterKey].forEach(filter => {
//         if (formattedOrFilters[name]) {
//           formattedOrFilters[name].push(transform(filter[value]))
//         } else {
//           formattedOrFilters[name] = [transform(filter[value])]
//         }
//       })

//       return formattedOrFilters
//     }, {})
//   }

//   const textSearch = filters.textSearch
//   const ranBetweenStart = filters.ranBetweenStart
//   const ranBetweenEnd = filters.ranBetweenEnd
//   const startedRunningStart = filters.startedRunningStart
//   const startedRunningEnd = filters.startedRunningEnd
//   const savedBetweenStart = filters.savedBetweenStart
//   const savedBetweenEnd = filters.savedBetweenEnd
//   const videoLengthMin = filters.videoLengthMin
//   const videoLengthMax = filters.videoLengthMax
//   const productCategoryQuery = filters.productCategoryQuery
//   const creativeTargetingQuery = filters.creativeTargetingQuery
//   const transcriptionCompleteOnly = filters.transcriptionCompleteOnly
//   const transciptionOnly = filters.transciptionOnly
//   const adLibraryIdExists = filters.adLibraryIdExists
//   const aiProccessedOnly = filters.aiProccessedOnly
//   const size = filters.size

//   const excludeTeamItems = filters.excludeTeamItems

//   return {
//     aiProccessedOnly,
//     sort,
//     size,
//     excludeTeamItems,
//     transciptionOnly,
//     transcriptionCompleteOnly,
//     ranBetweenStart,
//     ranBetweenEnd,
//     savedBetweenStart,
//     savedBetweenEnd,
//     startedRunningStart,
//     startedRunningEnd,
//     videoLengthMin,
//     videoLengthMax,
//     productCategoryQuery,
//     creativeTargetingQuery,
//     adLibraryIdExists,
//     favorites,
//     textSearch,
//     ...mappedAndFilters,
//     ...mappedOrFilters
//   }
// }

// export { conditionalFilterMaps }
